module.exports = __webpack_public_path__ + "img/img8.3c51cb9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/04/img8.png
// module id = 239
// module chunks = 0